export default __webpack_public_path__ + "static/media/coloregg2.d3a8a903.png";